
export default function InstagramPortfolio() {
  const posts = [
    {
      image: 'https://public.readdy.ai/ai/img_res/26acee83aa79cd70029f9f526361829e.jpg',
      caption: '클래식 프렌치 네일 💅 심플하지만 우아한 디자인',
      likes: 1243,
      shop: '다움네일살롱'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Natural%20eyelash%20extensions%20close-up%2C%20beautiful%20eye%20with%20volume%20lashes%2C%20professional%20lash%20work%2C%20soft%20feminine%20beauty%2C%20elegant%20makeup%20photography%2C%20premium%20beauty%20service%20result%2C%20clean%20aesthetic&width=400&height=400&seq=insta-lash-1&orientation=squarish',
      caption: '자연스러운 속눈썹 연장 ✨ 매일 아침이 편해져요',
      likes: 892,
      shop: '라벤더 아이래쉬'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Glowing%20healthy%20skin%20after%20facial%20treatment%2C%20radiant%20complexion%2C%20professional%20skincare%20result%2C%20soft%20pink%20tones%2C%20beauty%20wellness%20photography%2C%20premium%20spa%20service%2C%20elegant%20feminine%20aesthetic&width=400&height=400&seq=insta-skin-1&orientation=squarish',
      caption: '피부관리 후 촉촉한 광채 피부 🌸',
      likes: 2156,
      shop: '로즈 스킨케어'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Trendy%20gel%20nail%20art%20with%20pastel%20colors%20and%20floral%20design%2C%20modern%20nail%20decoration%2C%20professional%20manicure%20work%2C%20soft%20pink%20and%20lavender%20tones%2C%20luxury%20beauty%20content%2C%20elegant%20feminine%20style&width=400&height=400&seq=insta-nail-2&orientation=squarish',
      caption: '봄 시즌 플라워 네일 🌷 너무 예뻐요',
      likes: 1567,
      shop: '다움네일살롱'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20bridal%20makeup%20look%20with%20soft%20pink%20tones%2C%20elegant%20wedding%20beauty%2C%20professional%20makeup%20artistry%2C%20glowing%20skin%2C%20romantic%20feminine%20style%2C%20luxury%20beauty%20photography%2C%20sophisticated%20aesthetic&width=400&height=400&seq=insta-makeup-1&orientation=squarish',
      caption: '웨딩 메이크업 💕 특별한 날을 더 빛나게',
      likes: 3421,
      shop: '오로라 메이크업'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Stylish%20hair%20color%20transformation%2C%20soft%20balayage%20with%20rose%20gold%20tones%2C%20professional%20hair%20styling%2C%20elegant%20feminine%20hairstyle%2C%20luxury%20salon%20work%2C%20beautiful%20hair%20photography%2C%20modern%20beauty%20aesthetic&width=400&height=400&seq=insta-hair-1&orientation=squarish',
      caption: '로즈골드 발레아쥬 염색 ✨ 완전 만족',
      likes: 1834,
      shop: '페탈 헤어살롱'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Artistic%20nail%20design%20with%20geometric%20patterns%2C%20modern%20minimalist%20nail%20art%2C%20pastel%20pink%20and%20beige%20colors%2C%20professional%20manicure%20photography%2C%20elegant%20beauty%20content%2C%20sophisticated%20feminine%20style&width=400&height=400&seq=insta-nail-3&orientation=squarish',
      caption: '미니멀 라인 네일 디자인 💫',
      likes: 1092,
      shop: '다움네일살롱'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Relaxing%20spa%20treatment%20atmosphere%2C%20soft%20pink%20towels%20and%20beauty%20products%2C%20serene%20wellness%20environment%2C%20professional%20skincare%20setup%2C%20elegant%20feminine%20aesthetic%2C%20luxury%20beauty%20service%2C%20calming%20ambiance&width=400&height=400&seq=insta-spa-1&orientation=squarish',
      caption: '힐링 타임 🧖‍♀️ 나를 위한 시간',
      likes: 967,
      shop: '로즈 스킨케어'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Glamorous%20evening%20makeup%20with%20rose%20gold%20shimmer%2C%20elegant%20party%20beauty%20look%2C%20professional%20makeup%20artistry%2C%20sophisticated%20feminine%20style%2C%20luxury%20cosmetics%2C%20beautiful%20beauty%20photography&width=400&height=400&seq=insta-makeup-2&orientation=squarish',
      caption: '파티 메이크업 🎉 화려하게 변신',
      likes: 2234,
      shop: '오로라 메이크업'
    }
  ];

  const handleViewMore = () => {
    window.location.href = '/portfolio';
  };

  return (
    <section id="portfolio" className="py-24 px-6 bg-gradient-to-b from-pink-50/30 to-purple-50/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Portfolio & Reviews
          </h2>
          <p className="text-base text-gray-600 mb-3">실제 고객 후기와 포트폴리오는 인스타그램을 통해 실시간 업데이트됩니다</p>
          <div className="flex items-center justify-center space-x-2 text-rose-400">
            <i className="ri-instagram-line text-xl"></i>
            <span className="text-sm font-medium">Instagram 연동</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((post, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-80 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.caption}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex items-center space-x-2 text-white">
                      <i className="ri-heart-fill text-rose-400"></i>
                      <span className="text-sm font-medium">{post.likes.toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-5">
                <div className="flex items-center space-x-2 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 rounded-full">
                    <i className="ri-instagram-line text-white text-sm"></i>
                  </div>
                  <span className="text-xs font-medium text-gray-700">{post.shop}</span>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">{post.caption}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={handleViewMore}
            className="px-8 py-3 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-sm font-medium rounded-full hover:shadow-lg hover:scale-105 transition-all whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
          >
            <i className="ri-instagram-line text-lg"></i>
            <span>인스타그램에서 더보기</span>
          </button>
        </div>
      </div>
    </section>
  );
}
